import ProjectSession from "../../project-session"
import ProjectSingleViewProperties from "./productivity-proto"
import {ProjectAvailableMenuOptions} from "../project-properties"

export default class ProjectSingleViewTasksProperties extends ProjectSingleViewProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canCreateTask                      = true

        this.menuSections.settings              = true

        this.settingsSections.workItems         = false
        this.settingsSections.customFields      = true
        this.settingsSections.views             = false
        this.settingsSections.taskId            = true
        this.settingsSections.navigation        = false
        this.settingsSections.taskTypes         = true
        this.settingsSections.workflow          = true
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {
        const res = super.availableMenuOptions
        res.settings = true
        return res
    }
}
